import type { BetterFetch } from "@better-fetch/fetch";
import { audienceEndpointContract } from "../../shared/contracts/audience.contracts";
import {
	createQuerySetMap,
	extractListeners,
	extractQueries,
	extractSignals,
} from "../shared/queryFactory";

export function createAudiencePlugin($fetch: BetterFetch) {
	const querySets = createQuerySetMap(
		{
			listAudiences: {
				path: audienceEndpointContract.listAudiences.path,
				method: audienceEndpointContract.listAudiences.method,
			},
			searchAudience: {
				path: audienceEndpointContract.searchAudience.path,
				method: audienceEndpointContract.searchAudience.method,
			},
			searchAudienceMembers: {
				path: audienceEndpointContract.searchAudienceMembers.path,
				method: audienceEndpointContract.searchAudienceMembers.method,
			},
			createAudience: {
				path: audienceEndpointContract.createAudience.path,
				method: audienceEndpointContract.createAudience.method,
			},
			createAudienceMember: {
				path: audienceEndpointContract.createAudienceMember.path,
				method: audienceEndpointContract.createAudienceMember.method,
			},
			deleteAudience: {
				path: audienceEndpointContract.deleteAudience.path,
				method: audienceEndpointContract.deleteAudience.method,
			},
		},
		$fetch,
	);

	const signals = extractSignals(querySets);
	const queries = extractQueries(querySets);
	const listeners = extractListeners(querySets);

	return {
		querySets,
		signals,
		queries,
		listeners,
		atoms: {},
		actions: {},
	};
}
